import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { permissionStore, timStore, traceMatrixApiStore } from "@/hooks";
import { FlexBox, TextButton } from "@/components/common";

/**
 * Attempts to delete the selected trace matrix.
 */

/**
 * Displays trace matrix action buttons.
 */
const __default__ = {
  name: "TraceMatrixButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleDelete(): void {
  const traceMatrix = timStore.selectedTraceMatrix;

  if (!traceMatrix) return;

  traceMatrixApiStore.handleDeleteTypes(
    traceMatrix.sourceType,
    traceMatrix.targetType
  );
}

return (_ctx: any,_cache: any) => {
  return (_unref(permissionStore).isAllowed('project.edit_data'))
    ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            icon: "delete",
            label: "Delete",
            onClick: handleDelete
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})